import { fetcher } from '@commenda/utils';

export default async function deleteFile({
  fileId,
  nextAuthToken,
}: {
  fileId: number;
  nextAuthToken?: string;
}): Promise<boolean> {
  const res = await fetcher(
    `file/${fileId}`,
    {
      method: 'DELETE',
    },
    nextAuthToken
  );
  if (!res.ok) return false;

  return true;
}
